/**
 * Shared React Query `meta.invalidates` tag sets for mutations.
 * Pair with matching `meta.tags` on queries so the shared MutationCache can refetch.
 */

/** Mark stale without refetching so patched property-table pages keep stable row order. */
export const ARCHIVE_STALE_ONLY_TAGS = ['getProperties', 'getPropertyTableUnitsList'] as const;
/** Per-row cells cached by listing alias whose content changes when a listing is archived or unarchived. */
export const ARCHIVE_ROW_CELL_TAGS = ['propertyTableStatus', 'propertyTableUnitOptions'] as const;

// getProperties and getPropertyTableUnitsList are omitted — applyArchiveCacheUpdates patches those
// lists in place and marks them stale without refetching.
export const DEFAULT_ARCHIVE_INVALIDATES = ['getMultiplexUnits', 'zramOptions'] as const;

export const CREATE_LISTING_MUTATION_INVALIDATES = [
  'getProperties',
  'getMultiplexUnits',
  'getPropertyTableUnits',
  'zramOptions',
] as const;

/** The StreetEasy link grants permissions on syndicated listings, so every property-table list must refetch. */
export const STREET_EASY_LINK_INVALIDATES = ['getProperties', 'getPropertyTableUnitsList'] as const;
